// Optional homepage work. Browser HTTP cache owns bytes; System verifies them on use.
const config=document.querySelector('[data-system-prefetch]');
if(config){
 const data=JSON.parse(config.textContent),connection=navigator.connection;
 const allowed=()=>!connection?.saveData&&!['slow-2g','2g'].includes(connection?.effectiveType);
 const lifetime=new AbortController();let stopped=false,active=0,next=0,idle=0,timer=0,loaded=document.readyState==='complete';
 const queue=[...data.native.map(url=>({url,image:true})),...(innerWidth<=760?data.phone:data.desktop).map(url=>({url})),...data.stills.map(url=>({url}))];
 function mediaLoaded(){
  for(const img of document.images){
   if(!img.currentSrc&&!img.getAttribute('src'))continue;
   const r=img.getBoundingClientRect(),visible=r.bottom>0&&r.top<innerHeight&&r.right>0&&r.left<innerWidth;
   if((img.loading!=='lazy'||visible)&&!img.complete)return false;
  }
  for(const video of document.querySelectorAll('video')){
   if(!video.currentSrc&&!video.getAttribute('src'))continue;
   if(video.error)continue;
   if(video.readyState<4||!Number.isFinite(video.duration)||!video.buffered.length||video.buffered.end(video.buffered.length-1)<video.duration-.25)return false;
  }
  return true;
 }
 function stop(){stopped=true;lifetime.abort();if(idle)cancelIdleCallback(idle);clearTimeout(timer);}
 function schedule(){
  if(stopped||idle||timer||active>=2||next>=queue.length||!loaded||document.hidden)return;
  if(!allowed()){stop();return;}
  if(!mediaLoaded()){timer=setTimeout(()=>{timer=0;schedule();},500);return;}
  if('requestIdleCallback' in window)idle=requestIdleCallback(deadline=>{idle=0;if(deadline.timeRemaining()>0)pump();else schedule();});
  else timer=setTimeout(()=>{timer=0;pump();},1500);
 }
 function imageRequest(url){
  return new Promise((resolve,reject)=>{
   const image=new Image();image.fetchPriority='low';image.decoding='async';
   const abort=()=>{image.src='';reject(lifetime.signal.reason);};
   lifetime.signal.addEventListener('abort',abort,{once:true});
   const finish=fn=>()=>{lifetime.signal.removeEventListener('abort',abort);fn();};
   image.onload=finish(resolve);image.onerror=finish(reject);image.src=url;
  });
 }
 function fetchRequest(url){
  const transfer=new AbortController(),abort=()=>transfer.abort(lifetime.signal.reason);
  lifetime.signal.addEventListener('abort',abort,{once:true});
  return fetch(url,{signal:transfer.signal,cache:'default',priority:'low'}).then(response=>{if(!response.ok)throw Error('Optional media unavailable');return response.arrayBuffer();}).finally(()=>lifetime.signal.removeEventListener('abort',abort));
 }
 function pump(){
  if(stopped||document.hidden||!allowed()||!mediaLoaded())return schedule();
  while(active<2&&next<queue.length){
   const item=queue[next++];active++;
   const request=item.image?imageRequest(item.url):fetchRequest(item.url);
   request.catch(()=>{}).finally(()=>{active--;schedule();});
  }
 }
 window.addEventListener('load',()=>{loaded=true;schedule();},{once:true,signal:lifetime.signal});
 document.addEventListener('visibilitychange',schedule,{signal:lifetime.signal});
 connection?.addEventListener?.('change',schedule,{signal:lifetime.signal});
 window.addEventListener('pagehide',stop,{once:true});
 schedule();
}
